/*
 * @Description: 移动端注册页面
 * @Author: 陈威达
 * @Date: 2022-04-08 11:03:34
 * @LastEditors: liuzhezhe 3449223724@qq.com
 * @LastEditTime: 2022-10-24 15:09:02
 */

import { Button, Form, Input, message } from 'antd'
import CountDownBtn from '@/components/countDownBtn'
import Protocol from '@/components/registerForm/Protocol'
import Privacy from '@/components/registerForm/Privacy'
import User from '@/modules/user'
import styles from './register.scss'
import { useLocation, useNavigate } from 'react-router-dom'
import { useRef, useState } from 'react'
const Register = () => {
  // "?code=7o5NtaXQcqrI"
  const navigate = useNavigate()
  console.log('useLocation', useLocation())
  const { search } = useLocation()
  const res = search.match(/\?code=([\d\w]*)/)
  let inviterCode = ''
  if (res) {
    inviterCode = res[1]
  }
  console.log('inviterCode', inviterCode)

  const [form] = Form.useForm()
  const formRef = useRef()
  const user = new User()

  const [proModalVisible, handleProVisible] = useState(false)
  const [privacyModalVisible, handlePrivacyVisible] = useState(false)
  // const history = useHistory()
  const onFinish = async(values) => {
    console.log('values', values)
    const data = {
      ...values,
      inviterCode: inviterCode
    }
    const result = await handleRegister(data)

    console.log(result)
    if (result) {
      navigate('/register-success')
    }
  }
  // 注册请求
  const handleRegister = async(fields) => {
    // 加载信息
    const hide = message.loading('正在注册')
    try {
      await user.register(fields)
      hide()
      message.success('注册成功')
      return true
    } catch (error) {
      hide()
      console.log('error', error)
    }
  }

  const validateVcode = () => ({
    validator(_, value) {
      if (value) {
        const cnReg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
        if ((cnReg.test(value))) {
          return Promise.reject(new Error('验证码不能为中文'))
        } else {
          return Promise.resolve()
        }
      } else {
        return Promise.reject('验证码不能为空')
      }
    }
  })
  const phoneValid = () => ({
    validator(_, value) {
      return checkPhoneValue(value)
    }
  })
  const checkPhoneValue = async(value)=>{
    if (['', undefined].includes(value)) {
      return Promise.reject(new Error('请输入手机号!'))
    }
    if (value && value.length !== 11) {
      return Promise.reject(new Error('请输入11位的手机号!'))
    }
    if (!Number.isInteger(value - 0)) {
      return Promise.reject(new Error('请输入正确格式的手机号!'))
    }

    const phoneResult = await user.checkPhone({ phone: value })
    if (phoneResult) {
      return Promise.reject(new Error('手机号已注册'))
    } else {
      return Promise.resolve()
    }
  }
  const handleSend = () => {
    const { phone } = formRef.current.getFieldsValue(true)
    return checkPhoneValue(phone).then(()=>{
      user.sendCode({ phone })
      return Promise.resolve()
    }).catch((err)=>{
      return Promise.reject(err)
    })
  }
  const validatePwd = () => ({
    validator(_, value) {
      if (value) {
        const reg = new RegExp('^(?![A-Z]*$)(?![a-z]*$)(?![0-9]*$)(?![^a-zA-Z0-9]*$)\\S+$')
        const cnReg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
        if (value && (value.length < 8 || value.length > 35)) {
          return Promise.reject(new Error('请输入8到35位的密码'))
        }
        if (!(reg.test(value)) || (cnReg.test(value))) {
          return Promise.reject(new Error('密码需数字、字母小写、字母大写、字符两种及以上组合'))
        } else {
          return Promise.resolve()
        }
      } else {
        return Promise.reject('请输入密码')
      }
    }
  })
  const cnInputCheck = (event) => {
    return event.target.value.replace(/[\u4E00-\u9FA5]/g, '').replace(/\s/g, '')
  }

  return <div className={styles['container']}>
    <div className={styles['title']}>
      注册概而论账号
    </div>
    <Form
      form={form}
      ref={formRef}
      onFinish={onFinish}
    >
      <Form.Item
        name='nm'
        rules={[{ required: true, message: '姓名不能为空' }]}
      >
        <Input prefix={'姓名'} />
      </Form.Item>
      <Form.Item
        name='phone'
        rules={[
          phoneValid
        ]}
      >
        <Input prefix={'手机号'} />
      </Form.Item>
      <Form.Item style={{ marginBottom: 0 }}>
        <Form.Item
          name='code'
          rules={[validateVcode]}
          style={{ display: 'inline-block', width: 'calc(74% - 8px)' }}
          getValueFromEvent = {cnInputCheck}
        >
          <Input placeholder='请输入验证码' />
        </Form.Item>
        <Form.Item
          style={{ display: 'inline-block', width: 'calc(26% - 8px)', margin: '0 8px' }}
        >
          <CountDownBtn handleSend={handleSend}/>
        </Form.Item>
      </Form.Item>
      <Form.Item
        name='password'
        rules={[
          validatePwd
        ]}
        getValueFromEvent = {cnInputCheck}
      >
        <Input.Password placeholder='请输入8-35位字符密码' prefix={'密码'}/>

      </Form.Item>
      <div className={styles['btns']}>
        <Button type='primary' htmlType='submit' block >
        注册
        </Button>
      </div>
      <div className={styles['tip']}>
        注册代表您已同意
        <span className={styles['link']} onClick={() => handleProVisible(true)}>用户协议</span>和
        <span className={styles['link']} onClick={() => handlePrivacyVisible(true)}>用户隐私</span>
      </div>
    </Form>
    <Protocol modalVisible={proModalVisible} onCancel={() => handleProVisible(false)}/>
    <Privacy modalVisible={privacyModalVisible} onCancel={() => handlePrivacyVisible(false)}/>
  </div>
}

export default Register
